module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920-a8f486c1fdcf94f2921b9ede00daeb3e.jpg";